import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import "react";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ErrorAccessDeniedImage_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ErrorAccessDeniedImage_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const ErrorAccessDeniedImage = (t0)=>{
    const $ = c(32);
    let props;
    if ($[0] !== t0) {
        props = _extends({}, t0);
        $[0] = t0;
        $[1] = props;
    } else props = $[1];
    let t1;
    let t10;
    let t11;
    let t12;
    let t13;
    let t14;
    let t15;
    let t16;
    let t17;
    let t18;
    let t19;
    let t2;
    let t20;
    let t21;
    let t22;
    let t23;
    let t24;
    let t25;
    let t26;
    let t27;
    let t28;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ jsx("path", {
            d: "M48 100C48 60.2355 80.2355 28 120 28H153C192.764 28 225 60.2355 225 100C225 139.764 192.764 172 153 172H120C80.2355 172 48 139.764 48 100Z",
            fill: "#99BCFF"
        });
        t2 = /*#__PURE__*/ jsx("path", {
            d: "M75.8701 72.393C72.7412 70.0608 70.4113 66.513 71.4362 62.7477C72.8136 57.687 77.3554 51.0527 91.4759 49.6229L257.494 44.6449C269.266 44.2919 279 53.7383 279 65.5152C279 89.9645 279 114.848 279 132.789C279 145.337 268.828 155.5 256.28 155.5H240.5L186.508 151.808C183.565 151.607 180.742 150.562 178.377 148.799L75.8701 72.393Z",
            fill: "#D8E5FF"
        });
        t3 = /*#__PURE__*/ jsx("path", {
            d: "M277.72 132.789V65.5156C277.72 54.4608 268.583 45.5927 257.533 45.9238L91.5652 50.9004C84.7104 51.6002 80.3092 53.5465 77.4792 55.8213C74.6508 58.0948 73.3016 60.7693 72.6716 63.084C71.8534 66.09 73.6707 69.1573 76.6355 71.3672L179.141 147.773C181.309 149.39 183.898 150.347 186.595 150.531L240.545 154.22H256.28L256.28 155.5H240.5L186.508 151.808C183.749 151.62 181.096 150.689 178.826 149.121L178.377 148.799L75.8701 72.393C72.8391 70.1337 70.5571 66.7332 71.3494 63.0996L71.4362 62.7477C72.7921 57.766 77.2143 51.2592 90.821 49.6934L91.4759 49.6229L257.494 44.6449C269.266 44.2919 279 53.7383 279 65.5152V132.789C279 145.337 268.828 155.5 256.28 155.5L256.28 154.22C268.122 154.22 277.72 144.629 277.72 132.789Z",
            fill: "#226DFE"
        });
        t4 = /*#__PURE__*/ jsx("path", {
            d: "M71 65.2343C71 58.7116 76.2103 53.3834 82.7314 53.2374L255.151 49.3772C264.395 49.1703 272 56.607 272 65.8531V140.888C272 149.169 265.171 155.821 256.893 155.603L87.5533 151.151C78.3416 150.909 71 143.372 71 134.157V65.2343Z",
            fill: "#EDF3FF"
        });
        t5 = /*#__PURE__*/ jsx("path", {
            d: "M71 134.157V65.2343C71 58.8135 76.0488 53.5502 82.4268 53.248L82.7314 53.2374L255.151 49.3772C264.395 49.1703 272 56.607 272 65.8531V140.888C272 149.04 265.383 155.613 257.28 155.608L256.893 155.603L87.5533 151.151C78.3416 150.909 71 143.372 71 134.157ZM72.2803 134.157C72.2803 142.678 79.0688 149.648 87.5869 149.872L256.927 154.323C264.485 154.522 270.72 148.449 270.72 140.888V65.8535C270.72 57.3256 263.705 50.4664 255.18 50.6572L82.7598 54.5166C76.9344 54.6472 72.2803 59.4075 72.2803 65.2344V134.157Z",
            fill: "#226DFE"
        });
        t6 = /*#__PURE__*/ jsx("path", {
            d: "M77 89.9698C77 84.8843 79.6504 79.6369 84.1602 77.2865C85.7575 76.4541 87.7192 75.793 90.7177 75.5C90.7177 75.5 106.165 75.5373 126.467 75C139.473 74.9999 140 83.8963 140 90.0798C140 103.757 140 104.488 140 117.157C140 131.111 131.997 133 125.453 133C111.149 133 90.7112 131.111 90.7112 131.111C85.2977 131.111 77 124.639 77 118.171V89.9698Z",
            fill: "#D8E5FF"
        });
        t7 = /*#__PURE__*/ jsx("path", {
            d: "M77 118.171V89.9698C77 84.8843 79.6504 79.6369 84.1602 77.2865C85.7575 76.4541 87.7192 75.793 90.7177 75.5C90.7433 75.5001 106.181 75.5369 126.467 75C139.473 74.9999 140 83.8963 140 90.0798V117.157L139.994 117.802C139.75 131.169 131.895 133 125.453 133L125.453 131.72C128.647 131.72 131.919 131.248 134.39 129.305C136.799 127.41 138.72 123.89 138.72 117.157V90.0801C138.72 86.9626 138.567 83.5283 137.007 80.8682C135.536 78.3598 132.64 76.2803 126.468 76.2803C116.321 76.5486 107.388 76.6736 100.99 76.7314C97.7877 76.7604 95.2199 76.7724 93.4521 76.7773C92.5683 76.7798 91.884 76.7802 91.4209 76.7803H90.7871C87.9674 77.0615 86.1808 77.6772 84.752 78.4219C80.7412 80.5122 78.2803 85.2692 78.2803 89.9697V118.171C78.2803 120.881 80.0522 123.796 82.6719 126.106C85.293 128.418 88.4312 129.83 90.7109 129.83H90.7705L90.8291 129.836H90.832C90.8344 129.836 90.8389 129.836 90.8438 129.837C90.8534 129.838 90.8677 129.839 90.8867 129.841C90.9254 129.844 90.9834 129.851 91.0596 129.857C91.2118 129.871 91.4373 129.891 91.7295 129.917C92.3142 129.968 93.1662 130.042 94.2334 130.13C96.3682 130.307 99.3643 130.543 102.806 130.778C109.695 131.25 118.346 131.72 125.453 131.72L125.453 133L124.095 132.994C109.891 132.883 90.7112 131.111 90.7112 131.111C85.2977 131.111 77 124.639 77 118.171Z",
            fill: "#226DFE"
        });
        t8 = /*#__PURE__*/ jsx("path", {
            d: "M77 87.5716C77 83.3841 80.3546 79.9684 84.5414 79.8928L124.878 79.1647C129.889 79.0742 134 83.1115 134 88.1232V122.276C134 128.718 128.718 133.907 122.278 133.794L87.8856 133.191C81.843 133.085 77 128.156 77 122.113V87.5716Z",
            fill: "white"
        });
        t9 = /*#__PURE__*/ jsx("path", {
            d: "M77 122.113V87.5716C77 83.3841 80.3546 79.9684 84.5414 79.8928L124.878 79.1647L125.346 79.168C130.142 79.3275 134 83.2683 134 88.1232V122.276L133.996 122.577C133.837 128.778 128.782 133.746 122.579 133.796L122.278 133.794L87.8856 133.191C81.843 133.085 77 128.156 77 122.113ZM78.2803 122.112C78.2803 127.458 82.5636 131.817 87.9082 131.911L122.301 132.515C128.025 132.615 132.72 128.002 132.72 122.276V88.123C132.72 83.8273 129.196 80.3668 124.901 80.4443L84.5645 81.1729C81.0755 81.2359 78.2804 84.0818 78.2803 87.5713V122.112Z",
            fill: "#226DFE"
        });
        t10 = /*#__PURE__*/ jsx("path", {
            d: "M105 95C108.866 95.0002 111.999 98.3581 111.999 102.5C111.999 105.491 110.364 108.073 108 109.276V113.521C108 115.442 106.657 117 105 117C103.343 117 102 115.442 102 113.521V109.276C99.6355 108.073 98.0001 105.491 98 102.5C98 98.358 101.134 95 105 95Z",
            fill: "#D8E5FF"
        });
        t11 = /*#__PURE__*/ jsx("path", {
            d: "M106.72 113.521V108.492L107.419 108.136C109.28 107.188 110.632 105.158 110.715 102.735L110.719 102.5C110.719 99.0902 108.239 96.4499 105.287 96.2881L105 96.2803C102.019 96.2803 99.4459 98.8144 99.2881 102.173L99.2803 102.5C99.2804 105.026 100.66 107.158 102.581 108.136L103.28 108.491V113.521C103.28 114.92 104.222 115.72 105 115.72V117C103.343 117 102 115.442 102 113.521V109.276C99.6355 108.073 98.0001 105.491 98 102.5C98 98.358 101.134 95 105 95C108.866 95.0002 111.999 98.3581 111.999 102.5C111.999 105.491 110.364 108.073 108 109.276V113.521C108 115.442 106.657 117 105 117V115.72C105.778 115.72 106.72 114.92 106.72 113.521Z",
            fill: "#226DFE"
        });
        t12 = /*#__PURE__*/ jsx("path", {
            d: "M94.8649 55.0073C98.057 51.1615 102.539 48.8555 107.998 49.007C113.456 49.1586 117.943 51.1615 121.135 55.0073C124.327 58.853 125.995 64.0673 126 69.506V75.8196L124.14 77.9136L119.314 77.9136V69.506C119.345 67.6644 119.245 65.8338 118.681 64.1214C118.118 62.409 117.276 60.8493 116.206 59.5336C115.136 58.2179 113.859 57.1727 112.45 56.4591C111.04 55.7456 109.527 55.378 107.998 55.378C106.469 55.378 104.955 55.7456 103.546 56.4591C102.136 57.1727 100.859 58.2179 99.7888 59.5336C98.7187 60.8493 97.8773 62.409 97.3139 64.1214C96.7504 65.8338 96.6546 67.6644 96.6857 69.506V77L94.8649 78.5H90V69.5486C90.005 64.1099 91.6728 58.853 94.8649 55.0073Z",
            fill: "#B8CEFA"
        });
        t13 = /*#__PURE__*/ jsx("path", {
            d: "M107.998 49.007C113.456 49.1586 117.943 51.1615 121.135 55.0073C124.327 58.853 125.995 64.0673 126 69.506V75.8196L124.14 77.9136L119.314 77.9136V69.506C119.343 67.7793 119.257 66.0624 118.781 64.4435L118.681 64.1214C118.118 62.409 117.276 60.8493 116.206 59.5336C115.136 58.2179 113.859 57.1727 112.45 56.4591C111.128 55.7903 109.715 55.426 108.284 55.383L107.998 55.378C106.469 55.378 104.955 55.7456 103.546 56.4591L103.283 56.5968C101.978 57.3044 100.792 58.3003 99.7888 59.5336L99.5908 59.7833C98.6147 61.045 97.8421 62.5161 97.3139 64.1214C96.7504 65.8338 96.6546 67.6644 96.6857 69.506V77L94.8649 78.5H90V69.5486C90.0049 64.2799 91.5704 59.1821 94.5703 55.3722L94.8649 55.0073C98.057 51.1615 102.539 48.8555 107.998 49.007ZM107.962 50.2863C102.925 50.1466 98.8096 52.2592 95.8496 55.8253C92.8795 59.4039 91.2851 64.3565 91.2803 69.5499V77.2197H94.4053L95.4053 76.3955V69.5059C95.3745 67.628 95.4688 65.6332 96.0977 63.7218C96.7068 61.8705 97.6213 60.17 98.7959 58.7257C99.9708 57.2812 101.387 56.118 102.968 55.3175C104.55 54.5164 106.262 54.0978 107.998 54.0978C109.734 54.0979 111.445 54.5165 113.027 55.3175C114.609 56.118 116.024 57.2813 117.199 58.7257C118.374 60.17 119.288 61.8705 119.897 63.7218C120.526 65.6317 120.625 67.6251 120.594 69.5059L120.595 76.6338H123.564L124.72 75.333V69.5069C124.715 64.3161 123.122 59.4055 120.15 55.8253C117.224 52.3003 113.104 50.4291 107.962 50.2863Z",
            fill: "#226DFE"
        });
        t14 = /*#__PURE__*/ jsx("path", {
            d: "M238 88C238 84.6863 240.686 82 244 82C247.314 82 250 84.6863 250 88V114.974C250 118.288 247.314 120.974 244 120.974C240.686 120.974 238 118.288 238 114.974V88Z",
            fill: "#226DFE"
        });
        t15 = /*#__PURE__*/ jsx("path", {
            d: "M252.526 90.3621C254.985 88.6499 258.312 89.2913 259.958 91.7948C261.604 94.2982 260.945 97.7156 258.486 99.4278L242.077 110.856C239.618 112.568 236.291 111.927 234.645 109.423C232.999 106.92 233.658 103.502 236.116 101.79L252.526 90.3621Z",
            fill: "#226DFE"
        });
        t16 = /*#__PURE__*/ jsx("path", {
            d: "M257.886 103.021C260.446 104.509 261.366 107.82 259.941 110.415C258.252 113.491 254.424 114.555 251.391 112.791L239.65 105.964C236.854 104.338 235.849 100.721 237.406 97.8854C238.962 95.0497 242.491 94.0692 245.287 95.6952L257.886 103.021Z",
            fill: "#226DFE"
        });
        t17 = /*#__PURE__*/ jsx("path", {
            d: "M242.145 83.0256C245.107 83.0259 247.508 85.2351 247.508 87.9602V93.2151L250.611 91.2844C253.064 89.7571 256.399 90.3496 258.059 92.6067C259.719 94.8638 259.076 97.931 256.622 99.4583L253.48 101.413L256.066 102.758C258.841 104.201 259.82 107.441 258.252 109.994C256.684 112.548 253.163 113.449 250.387 112.006L247.508 110.509V117.066C247.508 119.791 245.107 122 242.145 122C239.183 122 236.781 119.791 236.781 117.066V111.81L234.587 113.176C232.134 114.703 228.799 114.112 227.139 111.855C225.479 109.598 226.122 106.53 228.576 105.002L232.369 102.64L227.934 100.335C225.159 98.8925 224.18 95.6534 225.747 93.0999C227.316 90.5463 230.837 89.6456 233.613 91.0881L236.781 92.7346V87.9602C236.781 85.2349 239.183 83.0256 242.145 83.0256Z",
            fill: "#D8E5FF"
        });
        t18 = /*#__PURE__*/ jsx("path", {
            d: "M246.508 117.066V108.862L250.849 111.118C253.192 112.336 256.126 111.547 257.401 109.471C258.603 107.513 257.95 105.004 255.816 103.762L255.605 103.646L251.462 101.491L256.094 98.6096C258.081 97.3728 258.549 94.9609 257.253 93.1995C255.918 91.3839 253.172 90.8685 251.14 92.1331L246.508 95.0149V87.9602C246.508 85.8642 244.635 84.0258 242.145 84.0256C239.655 84.0258 237.781 85.8643 237.781 87.9602V94.3811L233.152 91.9758C230.809 90.7583 227.875 91.5474 226.6 93.6233C225.359 95.6441 226.095 98.2514 228.396 99.4475L234.386 102.562L229.105 105.851C227.118 107.088 226.649 109.501 227.945 111.262C229.28 113.077 232.027 113.592 234.059 112.327L237.781 110.009V117.066C237.781 119.162 239.655 121 242.145 121L242.145 122C239.183 122 236.781 119.791 236.781 117.066V111.81L234.587 113.176C232.134 114.703 228.799 114.112 227.139 111.855C225.479 109.598 226.122 106.53 228.576 105.002L232.369 102.64L227.934 100.335C225.159 98.8925 224.18 95.6534 225.747 93.0999C227.316 90.5463 230.837 89.6456 233.613 91.0881L236.781 92.7346V87.9602C236.781 85.2349 239.183 83.0256 242.145 83.0256C245.107 83.0259 247.508 85.2351 247.508 87.9602V93.2151L250.611 91.2844C253.064 89.7571 256.399 90.3496 258.059 92.6067C259.719 94.8638 259.076 97.931 256.622 99.4583L253.48 101.413L256.066 102.758C258.841 104.201 259.82 107.441 258.252 109.994C256.684 112.548 253.163 113.449 250.387 112.006L247.508 110.509V117.066C247.508 119.791 245.107 122 242.145 122L242.145 121C244.557 121 246.391 119.275 246.503 117.261L246.508 117.066Z",
            fill: "#226DFE"
        });
        t19 = /*#__PURE__*/ jsx("path", {
            d: "M197 88C197 84.6863 199.686 82 203 82C206.314 82 209 84.6863 209 88V114.974C209 118.288 206.314 120.974 203 120.974C199.686 120.974 197 118.288 197 114.974V88Z",
            fill: "#226DFE"
        });
        t20 = /*#__PURE__*/ jsx("path", {
            d: "M211.82 90.5307C214.209 88.8669 217.442 89.4902 219.041 91.9228C220.641 94.3555 220.001 97.6764 217.612 99.3402L200.993 110.914C198.604 112.577 195.371 111.954 193.772 109.521C192.172 107.089 192.812 103.768 195.202 102.104L211.82 90.5307Z",
            fill: "#226DFE"
        });
        t21 = /*#__PURE__*/ jsx("path", {
            d: "M217.028 103.104C219.509 104.546 220.401 107.756 219.02 110.272C217.383 113.254 213.672 114.285 210.731 112.575L198.668 105.56C195.957 103.984 194.983 100.478 196.492 97.7286C198.001 94.9795 201.422 94.0289 204.133 95.6053L217.028 103.104Z",
            fill: "#226DFE"
        });
        t22 = /*#__PURE__*/ jsx("path", {
            d: "M201.144 83.0256C204.106 83.0256 206.508 85.2349 206.508 87.9602V93.2151L209.611 91.2844C212.064 89.7571 215.399 90.3496 217.059 92.6067C218.719 94.8638 218.076 97.931 215.622 99.4583L212.48 101.413L215.066 102.758C217.841 104.201 218.82 107.441 217.252 109.994C215.684 112.548 212.163 113.449 209.387 112.006L206.508 110.509V117.066C206.508 119.791 204.106 122 201.144 122C198.182 122 195.781 119.791 195.781 117.066V111.81L193.587 113.176C191.134 114.703 187.799 114.112 186.139 111.855C184.479 109.598 185.122 106.53 187.576 105.002L191.368 102.64L186.934 100.335C184.159 98.8925 183.18 95.6534 184.747 93.0999C186.316 90.5463 189.837 89.6456 192.613 91.0881L195.781 92.7346V87.9602C195.781 85.2351 198.182 83.0259 201.144 83.0256Z",
            fill: "#D8E5FF"
        });
        t23 = /*#__PURE__*/ jsx("path", {
            d: "M205.508 117.066V108.862L209.849 111.118C212.192 112.336 215.126 111.547 216.401 109.471C217.603 107.513 216.95 105.004 214.816 103.762L214.605 103.646L210.462 101.491L215.094 98.6096C217.081 97.3728 217.549 94.9609 216.253 93.1995C214.918 91.3839 212.172 90.8685 210.14 92.1331L205.508 95.0149V87.9602C205.508 85.8642 203.634 84.0256 201.144 84.0256C198.654 84.026 196.781 85.8643 196.781 87.9602V94.3811L192.152 91.9758C189.809 90.7582 186.875 91.5474 185.6 93.6233C184.359 95.6442 185.095 98.2514 187.396 99.4475L193.386 102.562L188.105 105.851C186.118 107.088 185.649 109.501 186.945 111.262C188.28 113.077 191.027 113.592 193.059 112.327L196.781 110.009V117.066C196.781 119.162 198.654 121 201.144 121L201.144 122C198.182 122 195.781 119.791 195.781 117.066V111.81L193.587 113.176C191.134 114.703 187.799 114.112 186.139 111.855C184.479 109.598 185.122 106.53 187.576 105.002L191.368 102.64L186.934 100.335C184.159 98.8925 183.18 95.6534 184.747 93.0999C186.316 90.5463 189.837 89.6456 192.613 91.0881L195.781 92.7346V87.9602C195.781 85.2351 198.182 83.0259 201.144 83.0256C204.106 83.0256 206.508 85.2349 206.508 87.9602V93.2151L209.611 91.2844C212.064 89.7571 215.399 90.3496 217.059 92.6067C218.719 94.8638 218.076 97.931 215.622 99.4583L212.48 101.413L215.066 102.758C217.841 104.201 218.82 107.441 217.252 109.994C215.684 112.548 212.163 113.449 209.387 112.006L206.508 110.509V117.066C206.508 119.791 204.106 122 201.144 122L201.144 121C203.556 121 205.391 119.275 205.503 117.261L205.508 117.066Z",
            fill: "#226DFE"
        });
        t24 = /*#__PURE__*/ jsx("path", {
            d: "M157 89C157 85.6863 159.687 83 163 83C166.314 83 169 85.6863 169 89V115C169 118.314 166.314 121 163 121C159.687 121 157 118.314 157 115V89Z",
            fill: "#226DFE"
        });
        t25 = /*#__PURE__*/ jsx("path", {
            d: "M171.881 91.3012C174.243 89.6974 177.452 90.3162 179.048 92.6833C180.644 95.0504 180.023 98.2694 177.661 99.8732L160.917 111.243C158.555 112.847 155.346 112.228 153.75 109.861C152.154 107.494 152.775 104.275 155.136 102.671L171.881 91.3012Z",
            fill: "#226DFE"
        });
        t26 = /*#__PURE__*/ jsx("path", {
            d: "M177.137 103.638C179.558 105.01 180.414 108.089 179.049 110.514C177.43 113.388 173.793 114.399 170.924 112.772L158.612 105.792C155.967 104.293 155.032 100.929 156.523 98.2796C158.015 95.6301 161.369 94.6979 164.014 96.1975L177.137 103.638Z",
            fill: "#226DFE"
        });
        t27 = /*#__PURE__*/ jsx("path", {
            d: "M161.145 84C164.107 84.0002 166.508 86.1545 166.508 88.8115V93.9355L169.611 92.0527C172.064 90.5637 175.399 91.1404 177.059 93.3408C178.719 95.5415 178.077 98.5333 175.623 100.022L172.481 101.929L175.066 103.239C177.841 104.646 178.82 107.805 177.252 110.295C175.684 112.785 172.163 113.662 169.387 112.256L166.508 110.796V117.188C166.508 119.846 164.107 122 161.145 122C158.182 122 155.781 119.846 155.781 117.188V112.064L153.587 113.396C151.134 114.886 147.799 114.309 146.139 112.108C144.479 109.908 145.122 106.916 147.575 105.427L151.368 103.124L146.934 100.877C144.158 99.4703 143.179 96.312 144.747 93.8223C146.316 91.3325 149.838 90.4537 152.614 91.8604L155.781 93.4648V88.8115C155.781 86.1543 158.182 84 161.145 84Z",
            fill: "#D8E5FF"
        });
        t28 = /*#__PURE__*/ jsx("path", {
            d: "M165.508 117.188V109.168L169.84 111.364C172.197 112.558 175.138 111.776 176.406 109.762C177.629 107.821 176.919 105.299 174.613 104.131L170.424 102.007L175.105 99.167C177.09 97.962 177.538 95.6365 176.261 93.9434C174.929 92.1787 172.173 91.6677 170.13 92.9072L165.508 95.7119V88.8115C165.508 86.8061 163.659 85.0002 161.145 85C158.63 85.0002 156.78 86.8062 156.78 88.8115V95.0928L152.162 92.752C149.806 91.5581 146.863 92.3409 145.594 94.3555C144.372 96.2961 145.081 98.8171 147.386 99.9854L153.426 103.045L148.095 106.281C146.109 107.486 145.661 109.813 146.938 111.506C148.269 113.271 151.026 113.782 153.068 112.542L156.78 110.287V117.188C156.78 119.194 158.63 121 161.145 121L161.145 122C158.182 122 155.781 119.846 155.781 117.188V112.064L153.587 113.396C151.134 114.886 147.799 114.309 146.139 112.108C144.479 109.908 145.122 106.916 147.575 105.427L151.368 103.124L146.934 100.877C144.158 99.4703 143.179 96.312 144.747 93.8223C146.316 91.3325 149.838 90.4537 152.614 91.8604L155.781 93.4648V88.8115C155.781 86.1543 158.182 84 161.145 84C164.107 84.0002 166.508 86.1545 166.508 88.8115V93.9355L169.611 92.0527C172.064 90.5637 175.399 91.1404 177.059 93.3408C178.719 95.5415 178.077 98.5333 175.623 100.022L172.481 101.929L175.066 103.239C177.841 104.646 178.82 107.805 177.252 110.295C175.684 112.785 172.163 113.662 169.387 112.256L166.508 110.796V117.188C166.508 119.846 164.107 122 161.145 122L161.145 121C163.659 121 165.508 119.194 165.508 117.188Z",
            fill: "#226DFE"
        });
        $[2] = t1;
        $[3] = t10;
        $[4] = t11;
        $[5] = t12;
        $[6] = t13;
        $[7] = t14;
        $[8] = t15;
        $[9] = t16;
        $[10] = t17;
        $[11] = t18;
        $[12] = t19;
        $[13] = t2;
        $[14] = t20;
        $[15] = t21;
        $[16] = t22;
        $[17] = t23;
        $[18] = t24;
        $[19] = t25;
        $[20] = t26;
        $[21] = t27;
        $[22] = t28;
        $[23] = t3;
        $[24] = t4;
        $[25] = t5;
        $[26] = t6;
        $[27] = t7;
        $[28] = t8;
        $[29] = t9;
    } else {
        t1 = $[2];
        t10 = $[3];
        t11 = $[4];
        t12 = $[5];
        t13 = $[6];
        t14 = $[7];
        t15 = $[8];
        t16 = $[9];
        t17 = $[10];
        t18 = $[11];
        t19 = $[12];
        t2 = $[13];
        t20 = $[14];
        t21 = $[15];
        t22 = $[16];
        t23 = $[17];
        t24 = $[18];
        t25 = $[19];
        t26 = $[20];
        t27 = $[21];
        t28 = $[22];
        t3 = $[23];
        t4 = $[24];
        t5 = $[25];
        t6 = $[26];
        t7 = $[27];
        t8 = $[28];
        t9 = $[29];
    }
    let t29;
    if ($[30] !== props) {
        t29 = /*#__PURE__*/ jsxs("svg", _object_spread_props(_object_spread({
            width: "340",
            height: "200",
            viewBox: "0 0 340 200",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, props), {
            children: [
                t1,
                t2,
                t3,
                t4,
                t5,
                t6,
                t7,
                t8,
                t9,
                t10,
                t11,
                t12,
                t13,
                t14,
                t15,
                t16,
                t17,
                t18,
                t19,
                t20,
                t21,
                t22,
                t23,
                t24,
                t25,
                t26,
                t27,
                t28
            ]
        }));
        $[30] = props;
        $[31] = t29;
    } else t29 = $[31];
    return t29;
};
export { ErrorAccessDeniedImage };
